type ReportColumnHeaderProps = {
  title: string
  maxWidth?: string
}

export function ReportColumnHeader({ title, maxWidth = '80px' }: ReportColumnHeaderProps) {
  return (
    <div
      className="leading-tight text-center"
      style={{
        maxWidth: maxWidth,
        wordWrap: 'break-word',
        whiteSpace: 'normal',
      }}
    >
      {title}
    </div>
  )
}
